import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=e3f24936"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"
import style0 from "./permissions.vue?vue&type=style&index=0&id=e3f24936&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports